// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f0DKZj {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--surface-neutral-white, #ffffff);
}

.fOg19h {
  margin: var(--spacing-2, 16px) var(--spacing-3, 24px) 0;
  padding: var(--spacing-1-5, 12px);
  font-size: var(--ibk-typography-fontSizeSm, 14px);
  color: var(--ibk-colors-neutral-600, #999999);
  font-style: italic;
  text-align: left;
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  border-left: 3px solid var(--ibk-colors-primary-500, #2563eb);
}

@media (max-width: 768px) {
  .f0DKZj {
    height: auto;
    min-height: 100vh;
  }

  .fOg19h {
    margin: var(--spacing-1-5, 12px) var(--spacing-2, 16px) 0;
    padding: var(--spacing-1, 8px);
  }
}

@media (max-width: 480px) {
  .fOg19h {
    margin: var(--spacing-1, 8px) var(--spacing-1-5, 12px) 0;
    padding: var(--spacing-1, 8px);
    font-size: var(--ibk-typography-fontSizeXs, 12px);
  }
}

.dmzr2q {
  background: var(--surface-neutral-white, #ffffff);
  border-radius: var(--radius-s, 4px);
  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));
  height: calc(100vh - 155px);
  min-height: 360px;
}

.f_axOX {
  margin: 0;
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);
  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);
  line-height: var(--type-paragraph-lg-regular-line-height, 24px);
  color: var(--ibk-colors-neutral-900, #1f1f1f);
}

.dwGtYr {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3, 24px);
}

.ij_5ZD {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  margin-bottom: var(--spacing-1-5);
}

.EZirPA {
  height: 1px;
  background: var(--border-neutral-soft, #e5e7eb);
  margin: var(--spacing-2, 16px) 0;
}

.pkNVo2 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.PrNTpX {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  position: relative !important;
  width: 100% !important;
  gap: var(--spacing-2, 16px) !important;
}

.ZV5zUE {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
}

.UKY_xO {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
}

.xWFdbM {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
}

.rf22_C {
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: var(--radius-xs);
  margin: calc(-1 * var(--spacing-0-5));
  padding: var(--spacing-0-5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rf22_C:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.b0MaNq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.hyRzZQ {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.IfjtYw {
  width: 24px;
  height: 24px;
}

.RLXs0W {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background: var(--ibk-colors-primary-orange-500, #d64000);
  color: var(--surface-neutral-white, #ffffff);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.R3VFGB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid var(--border-neutral-soft, #e5e7eb);
  color: var(--ibk-colors-neutral-600, #999999);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: 600;
}

.FndUGA {
  font-family: var(--font-family-base);
  font-size: var(--ibk-typography-fontSizeMd, 16px);
  font-weight: 400;
  color: var(--ibk-colors-neutral-900, #1f1f1f);
}

.z09HbF {
  color: var(--ibk-colors-neutral-600, #999999);
}

.XGfo3n {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  margin-top: 15px;
}

.N5cXJl {
  max-width: 500px;
}

.UoLBhM {
  margin: var(--spacing-0-5) 0 0;
  min-width: auto;
}

.kcNsr5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
  font-size: var(--ibk-typography-fontSizeSm, 14px);
  line-height: var(--type-paragraph-sm-line-height, 16px);
}

.d3Q4hZ,
.unaiap {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  flex-shrink: 0;
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.nbpvD6,
.XURG8G {
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: right;
  margin-left: var(--spacing-1);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.unaiap {
  align-self: self-start;
  margin-top: var(--spacing-0-5, 4px);
}

.XURG8G {
  margin-top: var(--spacing-0-5, 4px);
}

.otfoiZ {
  all: unset;
  box-sizing: border-box;
  gap: var(--spacing-0-5, 4px) !important;
  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px) !important;
  width: auto !important;
  height: auto !important;
  min-height: 24px !important;
  background: transparent !important;
  color: var(--ibk-colors-primary-orange-500, #d64000) !important;
  font-size: var(--ibk-typography-fontSizeSm, 14px) !important;
  font-weight: 500 !important;
  border-radius: var(--radius-xs, 2px) !important;
  transition: background-color 0.2s ease !important;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.otfoiZ:hover {
  background: var(--ibk-colors-primary-orange-50, #fff7ed) !important;
}

.otfoiZ:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.mjFwYF {
  width: 16px;
  height: 16px;
}

.tiBkGN {
  font-size: var(--type-paragraph-sm-font-size);
  color: var(--text-neutral-soft);
  font-style: italic;
  padding-left: 32px;
  margin-top: var(--spacing-1);
}

.MunVxL {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  flex: 1;
  max-width: 30%;
}

.n26cXy {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5, 4px);
  max-width: 60%;
}

.fqDX9o {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-width: 10%;
}

.n26cXy .XGfo3n {
  margin-top: 0 !important;
}

.ifmDU4 {
  font-size: var(--ibk-typography-fontSizeSm, 14px);
  font-weight: 500;
  color: inherit;
  padding-left: 8px;
}

.n26cXy .kcNsr5 {
  justify-content: flex-start !important;
  gap: var(--spacing-1, 8px) !important;
}

.n26cXy .d3Q4hZ,
.n26cXy .unaiap {
  width: 30% !important;
  text-align: left !important;
}

.n26cXy .nbpvD6,
.n26cXy .XURG8G {
  width: 70% !important;
  text-align: left !important;
  margin-left: 0 !important;
}

.n26cXy .JM4fB4 {
  display: block;
  color: var(--ibk-colors-neutral-600, #6b7280) !important;
  font-size: var(--ibk-typography-fontSizeXs, 12px) !important;
  margin-top: 16px;
  font-weight: normal;
}

.NWML3n {
  position: relative;
  margin: calc(-1 * var(--spacing-3, 24px)) calc(-1 * var(--spacing-3, 24px)) 0;
}

@media (max-width: 768px) {
  .NWML3n {
    margin: calc(-1 * var(--spacing-2, 16px)) calc(-1 * var(--spacing-2, 16px)) 0;
  }
}

.fy1VAV {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-0-5, 4px);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.JZH8uZ {
  display: inline-flex;
  align-items: center;
}

.nGNrIC {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  cursor: help;
}

.talyRQ {
  min-width: unset;
  margin: var(--spacing-2, 16px) var(--spacing-3, 24px) 0;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  border-radius: var(--radius-s, 4px);
}

.T9E3xz {
  min-width: initial;
  width: 360px;
  max-width: calc(100vw - var(--spacing-3) * 2);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  border-radius: var(--radius-s, 4px);
}

.PlznVk {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 200px);
  overflow-y: auto;
}

.lGulfi {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.np11sd {
  margin-top: auto;
  padding-top: var(--spacing-3, 24px);
}

.pfHx8b {
  all: unset;
  box-sizing: border-box;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;
  margin-left: var(--spacing-1);
}

.pfHx8b:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.pfHx8b:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-xs);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/Summary/Summary.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,uDAAuD;EACvD,iCAAiC;EACjC,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,mCAAmC;EACnC,6DAA6D;AAC/D;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yDAAyD;IACzD,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,wDAAwD;IACxD,8BAA8B;IAC9B,iDAAiD;EACnD;AACF;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,4DAA4D;EAC5D,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,4DAA4D;EAC5D,oCAAoC;EACpC,iDAAiD;EACjD,8DAA8D;EAC9D,+DAA+D;EAC/D,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,6BAA6B;EAC7B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;AACT;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;EACzD,4CAA4C;EAC5C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,uDAAuD;AACzD;;AAEA;;EAEE,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;;EAEE,wCAAwC;EACxC,+BAA+B;EAC/B,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,uCAAuC;EACvC,iEAAiE;EACjE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,+DAA+D;EAC/D,4DAA4D;EAC5D,2BAA2B;EAC3B,+CAA+C;EAC/C,iDAAiD;EACjD,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wDAAwD;EACxD,4DAA4D;EAC5D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE;IACE,6EAA6E;EAC/E;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uDAAuD;EACvD,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6CAA6C;EAC7C,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oDAAoD;EACpD,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".summaryFullScreen {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-neutral-white, #ffffff);\n}\n\n.deliveryNote {\n  margin: var(--spacing-2, 16px) var(--spacing-3, 24px) 0;\n  padding: var(--spacing-1-5, 12px);\n  font-size: var(--ibk-typography-fontSizeSm, 14px);\n  color: var(--ibk-colors-neutral-600, #999999);\n  font-style: italic;\n  text-align: left;\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  border-left: 3px solid var(--ibk-colors-primary-500, #2563eb);\n}\n\n@media (max-width: 768px) {\n  .summaryFullScreen {\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .deliveryNote {\n    margin: var(--spacing-1-5, 12px) var(--spacing-2, 16px) 0;\n    padding: var(--spacing-1, 8px);\n  }\n}\n\n@media (max-width: 480px) {\n  .deliveryNote {\n    margin: var(--spacing-1, 8px) var(--spacing-1-5, 12px) 0;\n    padding: var(--spacing-1, 8px);\n    font-size: var(--ibk-typography-fontSizeXs, 12px);\n  }\n}\n\n.summaryCard {\n  background: var(--surface-neutral-white, #ffffff);\n  border-radius: var(--radius-s, 4px);\n  box-shadow: var(--shadow-s, 0 2px 4px 0 rgba(0, 0, 0, 0.12));\n  height: calc(100vh - 155px);\n  min-height: 360px;\n}\n\n.summaryTitle {\n  margin: 0;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2) var(--spacing-3);\n  border-bottom: 1px solid var(--border-neutral-soft, #e5e7eb);\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: var(--type-paragraph-lg-regular-font-weight, 600);\n  line-height: var(--type-paragraph-lg-regular-line-height, 24px);\n  color: var(--ibk-colors-neutral-900, #1f1f1f);\n}\n\n.summarySteps {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-3, 24px);\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  margin-bottom: var(--spacing-1-5);\n}\n\n.summaryDivider {\n  height: 1px;\n  background: var(--border-neutral-soft, #e5e7eb);\n  margin: var(--spacing-2, 16px) 0;\n}\n\n.summaryStep {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.stepWrapper {\n  display: flex !important;\n  align-items: flex-start !important;\n  justify-content: space-between !important;\n  position: relative !important;\n  width: 100% !important;\n  gap: var(--spacing-2, 16px) !important;\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n}\n\n.stepHeaderClickable {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n}\n\n.stepHeaderStatic {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n}\n\n.clickableStepButton {\n  all: unset;\n  box-sizing: border-box;\n  cursor: pointer;\n  border-radius: var(--radius-xs);\n  margin: calc(-1 * var(--spacing-0-5));\n  padding: var(--spacing-0-5);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.clickableStepButton:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.stepInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.stepIconCompleted {\n  width: 24px;\n  height: 24px;\n}\n\n.stepIconActive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background: var(--ibk-colors-primary-orange-500, #d64000);\n  color: var(--surface-neutral-white, #ffffff);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepIconInactive {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border-neutral-soft, #e5e7eb);\n  color: var(--ibk-colors-neutral-600, #999999);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: 600;\n}\n\n.stepLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--ibk-typography-fontSizeMd, 16px);\n  font-weight: 400;\n  color: var(--ibk-colors-neutral-900, #1f1f1f);\n}\n\n.stepLabelInactive {\n  color: var(--ibk-colors-neutral-600, #999999);\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  margin-top: 15px;\n}\n\n.beneficiariesDismissedAlert {\n  max-width: 500px;\n}\n\n.repeatBeneficiariesDismissedAlertInner {\n  margin: var(--spacing-0-5) 0 0;\n  min-width: auto;\n}\n\n.stepDataItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 30px;\n  font-size: var(--ibk-typography-fontSizeSm, 14px);\n  line-height: var(--type-paragraph-sm-line-height, 16px);\n}\n\n.stepDataLabel,\n.stepDataLabelWithAnnotation {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  flex-shrink: 0;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.stepDataValue,\n.stepDataValueWithAnnotation {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: right;\n  margin-left: var(--spacing-1);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.stepDataLabelWithAnnotation {\n  align-self: self-start;\n  margin-top: var(--spacing-0-5, 4px);\n}\n\n.stepDataValueWithAnnotation {\n  margin-top: var(--spacing-0-5, 4px);\n}\n\n.editButton {\n  all: unset;\n  box-sizing: border-box;\n  gap: var(--spacing-0-5, 4px) !important;\n  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px) !important;\n  width: auto !important;\n  height: auto !important;\n  min-height: 24px !important;\n  background: transparent !important;\n  color: var(--ibk-colors-primary-orange-500, #d64000) !important;\n  font-size: var(--ibk-typography-fontSizeSm, 14px) !important;\n  font-weight: 500 !important;\n  border-radius: var(--radius-xs, 2px) !important;\n  transition: background-color 0.2s ease !important;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n}\n\n.editButton:hover {\n  background: var(--ibk-colors-primary-orange-50, #fff7ed) !important;\n}\n\n.editButton:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.editIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.emptyState {\n  font-size: var(--type-paragraph-sm-font-size);\n  color: var(--text-neutral-soft);\n  font-style: italic;\n  padding-left: 32px;\n  margin-top: var(--spacing-1);\n}\n\n.stepHeaderSection {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n  max-width: 30%;\n}\n\n.stepDataSection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5, 4px);\n  max-width: 60%;\n}\n\n.stepEditSection {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  max-width: 10%;\n}\n\n.stepDataSection .stepContent {\n  margin-top: 0 !important;\n}\n\n.editButtonText {\n  font-size: var(--ibk-typography-fontSizeSm, 14px);\n  font-weight: 500;\n  color: inherit;\n  padding-left: 8px;\n}\n\n.stepDataSection .stepDataItem {\n  justify-content: flex-start !important;\n  gap: var(--spacing-1, 8px) !important;\n}\n\n.stepDataSection .stepDataLabel,\n.stepDataSection .stepDataLabelWithAnnotation {\n  width: 30% !important;\n  text-align: left !important;\n}\n\n.stepDataSection .stepDataValue,\n.stepDataSection .stepDataValueWithAnnotation {\n  width: 70% !important;\n  text-align: left !important;\n  margin-left: 0 !important;\n}\n\n.stepDataSection .stepDataAnnotation {\n  display: block;\n  color: var(--ibk-colors-neutral-600, #6b7280) !important;\n  font-size: var(--ibk-typography-fontSizeXs, 12px) !important;\n  margin-top: 16px;\n  font-weight: normal;\n}\n\n.emissorSummaryContent {\n  position: relative;\n  margin: calc(-1 * var(--spacing-3, 24px)) calc(-1 * var(--spacing-3, 24px)) 0;\n}\n\n@media (max-width: 768px) {\n  .emissorSummaryContent {\n    margin: calc(-1 * var(--spacing-2, 16px)) calc(-1 * var(--spacing-2, 16px)) 0;\n  }\n}\n\n.deliveryAddressValue {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-0-5, 4px);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.deliveryAnnotationTooltip {\n  display: inline-flex;\n  align-items: center;\n}\n\n.deliveryAnnotationIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n  cursor: help;\n}\n\n.warningAlert {\n  min-width: unset;\n  margin: var(--spacing-2, 16px) var(--spacing-3, 24px) 0;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n  border-radius: var(--radius-s, 4px);\n}\n\n.errorAlertToast {\n  min-width: initial;\n  width: 360px;\n  max-width: calc(100vw - var(--spacing-3) * 2);\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n  border-radius: var(--radius-s, 4px);\n}\n\n.summaryContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.summaryContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.summaryFooter {\n  margin-top: auto;\n  padding-top: var(--spacing-3, 24px);\n}\n\n.viewBeneficiariesLink {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  cursor: pointer;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n  margin-left: var(--spacing-1);\n}\n\n.viewBeneficiariesLink:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n.viewBeneficiariesLink:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryFullScreen": `f0DKZj`,
	"deliveryNote": `fOg19h`,
	"summaryCard": `dmzr2q`,
	"summaryTitle": `f_axOX`,
	"summarySteps": `dwGtYr`,
	"summarySection": `ij_5ZD`,
	"summaryDivider": `EZirPA`,
	"summaryStep": `pkNVo2`,
	"stepWrapper": `PrNTpX`,
	"stepHeader": `ZV5zUE`,
	"stepHeaderClickable": `UKY_xO`,
	"stepHeaderStatic": `xWFdbM`,
	"clickableStepButton": `rf22_C`,
	"stepIcon": `b0MaNq`,
	"stepInfo": `hyRzZQ`,
	"stepIconCompleted": `IfjtYw`,
	"stepIconActive": `RLXs0W`,
	"stepIconInactive": `R3VFGB`,
	"stepLabel": `FndUGA`,
	"stepLabelInactive": `z09HbF`,
	"stepContent": `XGfo3n`,
	"beneficiariesDismissedAlert": `N5cXJl`,
	"repeatBeneficiariesDismissedAlertInner": `UoLBhM`,
	"stepDataItem": `kcNsr5`,
	"stepDataLabel": `d3Q4hZ`,
	"stepDataLabelWithAnnotation": `unaiap`,
	"stepDataValue": `nbpvD6`,
	"stepDataValueWithAnnotation": `XURG8G`,
	"editButton": `otfoiZ`,
	"editIcon": `mjFwYF`,
	"emptyState": `tiBkGN`,
	"stepHeaderSection": `MunVxL`,
	"stepDataSection": `n26cXy`,
	"stepEditSection": `fqDX9o`,
	"editButtonText": `ifmDU4`,
	"stepDataAnnotation": `JM4fB4`,
	"emissorSummaryContent": `NWML3n`,
	"deliveryAddressValue": `fy1VAV`,
	"deliveryAnnotationTooltip": `JZH8uZ`,
	"deliveryAnnotationIcon": `nGNrIC`,
	"warningAlert": `talyRQ`,
	"errorAlertToast": `T9E3xz`,
	"summaryContainer": `PlznVk`,
	"summaryContent": `lGulfi`,
	"summaryFooter": `np11sd`,
	"viewBeneficiariesLink": `pfHx8b`
};
module.exports = ___CSS_LOADER_EXPORT___;
